import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import Button from '@shared/components/core/button/CoreButton';
import PageHeader from '@shared/components/core/headers/PageHeader';
import SpacedLoader from '@shared/components/loading/SpacedLoader';
import OrgPageContent from '@shared/components/organization/OrgPageContent';
import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useCurrentOrgNavigation } from '@shared/hooks/useCurrentOrgNavigation';
import OrgPageTemplate from 'admin/components/organization/OrgPageTemplate';
import { useTranslation } from 'react-i18next';

export default function OrgDetailPage() {
    useCurrentOrgNavigation();
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();
    const { currentOrg, isLoading } = useCurrentOrgDetailsFetching();

    if (!currentOrg || isLoading) return <SpacedLoader />;

    return (
        <OrgPageTemplate>
            <PageHeader
                title={currentOrg?.name ?? t('common:organization.title')}
                description={currentOrg?.description ?? t('common:organization.description')}
                items={items}>
                {(currentOrg?.customResourcesMarkdown || currentOrg?.managedResourcesMarkdown) && (
                    <Button $color="secondary" href={`#/org/${currentOrg?.id}/documentation`}>
                        {t('common:resources.title')}
                    </Button>
                )}
            </PageHeader>
            {currentOrg && <OrgPageContent isAdminPortal />}
        </OrgPageTemplate>
    );
}
